<template>
  <div class="flex flex-col w-full relative">
    <div class="grow w-full" style="position: relative; background-color: white">
      <div class="scrollable-container mx-4">
        <FleetFreeGlider />
      </div>
    </div>
    <div class="flex shrink-0 !grow-0 w-full mt-auto items-center gap-2">
      <v-btn :disabled="!btnActif" @click="saveConfig()" small color="primary" class="ml-auto !grow-0"
        >{{ $t('Pilot.MissionPlan.PublishStagingToIris') }}<v-icon small right>mdi-content-save</v-icon></v-btn
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue'
import store from '@/store'
import { AloDbFleet, AloDbFleetFree } from '@/models/alodb/AloDbFleet'
import FleetFreeGlider from '@/components/fleet/FleetFreeGlider.vue'
import deepEqual from 'deep-equal'

const props = defineProps<{
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
}>()

const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleetFree)
const original = computed(() => store.myGetters.originalAdmAdminFleet as AloDbFleetFree)

const btnActif = computed(() => !deepEqual(original.value, modified.value) /*&& !editCoverageState.value!.saving*/)

async function saveConfig() {
  await store.myActions.ADMINFLEET_SAVE_REQUEST()
}
</script>
